module.exports = __webpack_public_path__ + "static/media/fonction.1f2a0e37.png";